import { render, staticRenderFns } from "./ListTour.vue?vue&type=template&id=444a57f4&scoped=true&"
import script from "./ListTour.vue?vue&type=script&lang=js&"
export * from "./ListTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a57f4",
  null
  
)

export default component.exports